import { StationLongDto } from '@api/rest';

export interface ProfileData {
  acceptTerms: boolean,
  readInstructions: boolean,
  ageGroup: AgeGroup,
  avatar: Avatar;
  name?: string;
  selectedSituations?: string[],
  noMatching: boolean,
  goals: GoalPage[],
  goal: Goal
}

export enum Avatar {
  bear = 'avatar_bear',
  bunny = 'avatar_bunny',
  cat = 'avatar_cat',
  ladybug = 'avatar_ladybug',
  pig = 'avatar_pig',
}

export enum AgeGroup {
  tenToFourteen = '10-14',
  fifteenToSeventeen = '15-17'
}

export enum Goal {
  familyAndSocial = 'goal_family_and_social',
  reflectedDecisionsRegulatedEmotions = 'goal_reflected_decisions_regulated_emotions',
  dailyJoyMoreInterest = 'goal_daily_joy_more_interest',
  enjoyHealthyFood = 'goal_enjoy_healthy_food',
  general = 'goal_general'
}

export interface GoalPage {
  page: number,
  goal: Goal
}

export interface Question {
  station: StationLongDto,
  goal: Goal
}